import React from 'react';
import type { ViewStyle } from 'react-native';
import { TouchableOpacity, View, StyleSheet } from 'react-native';
import Cta from './Cta';
import Colors from 'src/core/utils/Colors';
import Dimens from 'src/core/utils/Dimens';

interface SubmitButtonProps {
	label: string;
	onPress: () => void;
	isLoading?: boolean;
	disabled?: boolean;
	style?: ViewStyle;
}

export default function SubmitButton({ label, onPress, isLoading = false, disabled, style }: SubmitButtonProps) {
	const inactive = disabled ?? isLoading;
	return (
		<View style={[styles.wrapper, style]}>
			<TouchableOpacity disabled={inactive} onPress={onPress}>
				<Cta
					buttonStyle="primary"
					disabled={inactive}
					isLoading={isLoading}
					label={label}
					labelColor={Colors.white}
					upperCase={true}
				/>
			</TouchableOpacity>
		</View>
	);
}

const styles = StyleSheet.create({
	wrapper: {
		marginTop: Dimens.margin16,
		flexDirection: 'row',
		justifyContent: 'center',
	},
});
